import { Step, StepButton, Stepper, Typography } from '@mui/material';
import { ReactElement } from 'react';

interface FormStepperProps {
  steps: StepModel[];
  activeStep: number;
  onChange: (stepValue: number) => void;
  width?: string | number;
}

export type StepModel = {
  value: number;
  text: string;
  caption?: string;
};

export function FormStepper({ steps, activeStep, onChange, width }: FormStepperProps): ReactElement {
  return (
    <Stepper activeStep={activeStep} nonLinear sx={{ padding: '24px', borderBottom: '1px solid rgba(0, 0, 0, 0.12)', width: width }}>
      {steps.map((step) => (
        <Step key={step.value} completed={activeStep !== step.value && activeStep > step.value}>
          <StepButton onClick={() => onChange(step.value)}>
            <Typography fontWeight={activeStep === step.value ? 'bold' : 'normal'}>
              {step.text}
              {step.caption && (
                <>
                  <br />
                  <span style={{ fontSize: 'smaller', fontWeight: 'normal' }}>{step.caption}</span>
                </>
              )}
            </Typography>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
}
